import { css, cx } from "@emotion/css";
import { fontSize, themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import type { Key, KeyPath } from "./types";
/**
 * Renders simple values (eg. strings, numbers, booleans, etc)
 */
interface Props {
    key: Key;
    keyPath: KeyPath;
    nodeType: string;
    value: unknown;
    valueGetter?: (value: unknown) => unknown;
}
export default function JSONValueNode({ nodeType, keyPath, value, valueGetter = (value) => value }: Props) {
    return (<li className={cx(valueStyles.base, valueStyles.withKeyPath(keyPath.length))}>
            <label>
                <span>{keyPath[0]}:</span>
            </label>
            {/* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */}
            <span className={valueTextStyles.byType(nodeType)}>{valueGetter(value) as React.ReactNode}</span>
        </li>);
}
const valueTextStyles = {
    byType: (nodeType: string) => css({
        fontSize: fontSize.medium,
        color: nodeType === "String" ? themeTokens.color.text.success : themeTokens.color.text.primary,
    }),
};
const valueStyles = {
    base: css({
        paddingTop: "0.25em",
        paddingRight: 0,
        marginLeft: "0.875em",
        userSelect: "text",
        wordWrap: "break-word",
        textIndent: "-0.5em",
        wordBreak: "break-all",
    }),
    withKeyPath: (keyPathLength: number) => css({
        paddingLeft: keyPathLength > 1 ? "2.125em" : "1.25em",
    }),
};
